<template>
  <div class="row mb-5">
    <el-table
      class="table-responsive align-items-center table-flush"
      header-row-class-name="thead-light"
      :data="resellerInvoice.items"
    >
      <el-table-column :label="$t('COMMON.CODE')" prop="code">
        <template v-slot="{ row }">
          <div v-if="row.resellerInvoiceable">
            <a
              href="#"
              @click.prevent="goToResellerInvoiceable(row.resellerInvoiceable)"
            >
              {{ row.code }}<br />
              <div
                class="text-muted resellerInvoice-item-excerpt"
                v-html="row.excerpt"
              ></div>
            </a>
          </div>
          <div v-if="!row.resellerInvoiceable">
            {{ row.code }}<br />
            <div
              class="text-muted resellerInvoice-item-excerpt"
              v-html="row.excerpt"
            ></div>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('COMMON.UNIT_PRICE')" prop="unit_price">
        <template v-slot="{ row }">
          {{ $formatCurrency(row.unit_price) }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('COMMON.QUANTITY')" prop="quantity" />

      <el-table-column :label="$t('COMMON.SUBTOTAL')" prop="discount">
        <template v-slot="{ row }">
          {{ $formatCurrency(row.pricing.subtotal) }}
        </template>
      </el-table-column>

      <el-table-column :label="$t('COMMON.DISCOUNT')" prop="discount">
        <template v-slot="{ row }">
          {{ $formatCurrency(row.pricing.discount_amount) }}
          <span class="text-muted">({{ row.discount }}%)</span>
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('COMMON.TAXES')"
        class-name="text-center"
        label-class-name="text-center"
      >
        <template v-slot="{ row }">
          <span
            v-for="tax in getItemTaxLabels(row)"
            :key="tax"
            class="badge badge-secondary mr-1"
          >
            {{ tax }}
          </span>
        </template>
      </el-table-column>

      <el-table-column min-width="50px" align="center">
        <div slot-scope="{ row }" class="table-actions">
          <el-tooltip
            :content="$t('COMMON.EDIT')"
            placement="top"
            v-if="resellerInvoice.status === INVOICE_STATUS_DRAFT"
          >
            <a
              type="text"
              @click="openResellerInvoiceItemModal(row)"
              class="table-action"
              data-toggle="tooltip"
              style="cursor: pointer"
            >
              <i class="fas fa-edit"></i>
            </a>
          </el-tooltip>
        </div>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import formMixin from "@/mixins/form-mixin";
import taxDisplayMixin from "@/mixins/tax-display-mixin";
import { INVOICE_STATUS_DRAFT } from "@/constants/invoices";

export default {
  name: "resellerInvoice-view-details-resellerInvoice-item-table",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
  },

  mixins: [formMixin, taxDisplayMixin],

  props: ["resellerInvoice"],

  data() {
    return {
      INVOICE_STATUS_DRAFT: INVOICE_STATUS_DRAFT,
    };
  },

  computed: {},

  methods: {
    openResellerInvoiceItemModal(resellerInvoiceItem) {
      this.$emit("onOpenResellerInvoiceItemModal", resellerInvoiceItem);
    },

    async goToResellerInvoiceable(resellerInvoiceable) {
      this.$router.push(this.$objectViewRoute(resellerInvoiceable));
    },

    getItemTaxLabels(row) {
      return this.getInvoiceItemTaxLabels(row);
    },
  },

  mounted() {},

  watch: {},
};
</script>

<style>
.resellerInvoice-item-excerpt p,
.resellerInvoice-item-excerpt,
.resellerInvoice-item-excerpt * {
  font-size: 0.7rem;
}
</style>
